export const EditModeEnum = {
  Always :1,
  Once:2,
  Never:3
}

Object.freeze(EditModeEnum);

export default EditModeEnum;